import { UtpCardStructure } from 'common/components';
import { ENTRANCE_DOORS_CDN_PATH } from '../../entrance-doors-constants';
import { WarmDoor, IndividualSize, DurableSteel, ReliableLocks } from './components';

export const ENTRANCE_DOORS_HOUSE_CARD_LIST: UtpCardStructure<{
  onConsultationSignupBtnClick: () => void;
}>[] = [
  {
    elementName: 'Теплоизоляция и терморазрыв',
    header: {
      title: 'Теплоизоляция и\u00A0терморазрыв',
    },
    description: {
      text: 'Поможем сохранить тепло в\u00A0холодное время года',
      mobileText: 'Поможем сохранить тепло в\u00A0холодный сезон ',
    },
    image: {
      alt: 'Утеплённая дверь',
      src: `${ENTRANCE_DOORS_CDN_PATH}/house-section/warm-door.png/warm-door-2.png`,
    },
    modal: { content: WarmDoor },
  },
  {
    elementName: 'Индивидуальные размеры',
    header: {
      title: 'Индивидуальные размеры',
    },
    description: {
      text: 'Изготовим дверь любого размера и\u00A0формата',
    },
    image: {
      alt: 'Индивидуальные размеры двери',
      src: `${ENTRANCE_DOORS_CDN_PATH}/house-section/individual-size.png/individual-size-2.png`,
    },
    modal: { content: IndividualSize },
  },
  {
    elementName: 'Прочная сталь толщиной от 1,5 мм',
    header: {
      title: 'Прочная сталь толщиной от\u00A01,5\u00A0мм',
    },
    description: {
      text: 'Гарантируем долговечность вашей двери',
      mobileText: 'Гарантируем долговечность',
    },
    image: {
      alt: 'Прочная сталь',
      src: `${ENTRANCE_DOORS_CDN_PATH}/house-section/durable-steel.png/durable-steel-2.png`,
    },
    modal: { content: DurableSteel },
  },
  {
    elementName: 'Надёжная система замков',
    header: {
      title: 'Надёжная система замков',
    },
    description: {
      text: 'Обеспечим защиту частного дома, коттеджа или\u00A0дачи',
    },
    image: {
      alt: 'Надёжные замки для двери',
      src: `${ENTRANCE_DOORS_CDN_PATH}/house-section/reliable-locks.png/reliable-locks-2.png`,
    },
    modal: { content: ReliableLocks },
  },
];
